import EntityConstants from "../configs/EntityConstants";
import { DEL, GET, POST } from "./CRUDService";

export const WHITE_LABEL_TERMINAL_STATUSES = ["ACTIVE", "FAILED"];

// Client-side pre-check only — a submitted apex domain (e.g. "clientco.com")
// is rejected before the round trip; the backend rejects it too either way.
export const isLikelySubdomain = (domain) => {
  if (typeof domain !== "string") return false;
  const trimmed = domain.trim().toLowerCase();
  if (!trimmed) return false;
  const labels = trimmed.split(".").filter(Boolean);
  return labels.length >= 3;
};

const parseJsonSafe = async (response) => {
  try {
    return await response.json();
  } catch {
    return {};
  }
};

export const fetchWhiteLabelConfigStatus = async () => {
  const response = await GET(EntityConstants.WHITE_LABEL_CONFIG_STATUS);
  const body = await parseJsonSafe(response);
  if (!response.ok) {
    throw new Error(body?.message || "Failed to fetch custom domain status");
  }
  return body.data;
};

export const submitWhiteLabelDomain = async (domain) => {
  const response = await POST(EntityConstants.WHITE_LABEL_SUBMIT, { domain });
  const body = await parseJsonSafe(response);
  if (!response.ok) {
    const error = new Error(body?.message || "Failed to submit domain");
    error.status = response.status;
    throw error;
  }
  return body;
};

export const retriggerWhiteLabelOnboarding = async () => {
  const response = await POST(EntityConstants.WHITE_LABEL_RETRIGGER, {});
  const body = await parseJsonSafe(response);
  if (!response.ok) {
    const error = new Error(
      body?.message || "Failed to retry domain onboarding",
    );
    error.status = response.status;
    throw error;
  }
  return body;
};


export const deleteWhiteLabelDomain = async () => {
  const response = await DEL(EntityConstants.WHITE_LABEL_REMOVE, {});
  const body = await parseJsonSafe(response);
  if (!response.ok) {
    const error = new Error(body?.message || "Failed to remove domain");
    error.status = response.status;
    throw error;
  }
  return body;
};
